import { AuditRequest, CallDirection, FilterOption, PaginationInfo } from '../../../types';
import { RecoilState, RecoilValueReadOnly } from 'recoil';
import {
  outboundTrafficMonitorDataState,
  outboundTrafficMonitorDirectionState,
  outboundTrafficMonitorEndDateState,
  outboundTrafficMonitorFiltersState,
  outboundTrafficMonitorOrderByColumnState,
  outboundTrafficMonitorOrderByDescendingState,
  outboundTrafficMonitorPageNumberState,
  outboundTrafficMonitorPageSizeState,
  outboundTrafficMonitorPaginationState,
  outboundTrafficMonitorRequestState,
  outboundTrafficMonitorSortByState,
  outboundTrafficMonitorStartDateState,
  outboundTrafficMonitorTextSearchState,
  trafficMonitorDataState,
  trafficMonitorDirectionState,
  trafficMonitorEndDateState,
  trafficMonitorFiltersState,
  trafficMonitorOrderByColumnState,
  trafficMonitorOrderByDescendingState,
  trafficMonitorPageNumberState,
  trafficMonitorPageSizeState,
  trafficMonitorPaginationState,
  trafficMonitorRequestState,
  trafficMonitorSortByState,
  trafficMonitorStartDateState,
  trafficMonitorTextSearchState,
} from '../../../store';
import { useState } from 'react';
import { GetAuditRequestsRequest } from '../../../api';
import { SortingRule } from 'react-table';

export type UseTrafficMonitorStateReturn = {
  requestState: RecoilValueReadOnly<GetAuditRequestsRequest>;
  filterState: RecoilState<FilterOption[]>;
  sortByState: RecoilValueReadOnly<SortingRule<AuditRequest>[]>;
  pageNumberState: RecoilState<number>;
  pageSizeState: RecoilState<number>;
  startDateState: RecoilState<Date>;
  endDateState: RecoilState<Date>;
  directionState: RecoilState<string>;
  orderByColumnState: RecoilState<string | undefined>;
  orderByDescendingState: RecoilState<boolean>;
  textSearchState: RecoilState<string>;
  resultsDataState: RecoilState<AuditRequest[]>;
  paginationState: RecoilState<PaginationInfo>;
};

export const UseTrafficMonitorState = (
  direction: CallDirection = 'Inbound'
): UseTrafficMonitorStateReturn => {
  const [callDirection] = useState(direction);

  const requestState =
    callDirection === 'Inbound'
      ? trafficMonitorRequestState
      : outboundTrafficMonitorRequestState;

  const filterState =
    callDirection === 'Inbound'
      ? trafficMonitorFiltersState
      : outboundTrafficMonitorFiltersState;

  const sortByState =
    callDirection === 'Inbound'
      ? trafficMonitorSortByState
      : outboundTrafficMonitorSortByState;

  const orderByColumnState =
    callDirection === 'Inbound'
      ? trafficMonitorOrderByColumnState
      : outboundTrafficMonitorOrderByColumnState;

  const orderByDescendingState =
    callDirection === 'Inbound'
      ? trafficMonitorOrderByDescendingState
      : outboundTrafficMonitorOrderByDescendingState;

  const pageNumberState =
    callDirection === 'Inbound'
      ? trafficMonitorPageNumberState
      : outboundTrafficMonitorPageNumberState;

  const pageSizeState =
    callDirection === 'Inbound'
      ? trafficMonitorPageSizeState
      : outboundTrafficMonitorPageSizeState;

  const startDateState =
    callDirection === 'Inbound'
      ? trafficMonitorStartDateState
      : outboundTrafficMonitorStartDateState;

  const endDateState =
    callDirection === 'Inbound'
      ? trafficMonitorEndDateState
      : outboundTrafficMonitorEndDateState;

  const directionState =
    callDirection === 'Inbound'
      ? trafficMonitorDirectionState
      : outboundTrafficMonitorDirectionState;

  const textSearchState =
    callDirection === 'Inbound'
      ? trafficMonitorTextSearchState
      : outboundTrafficMonitorTextSearchState;

  const resultsDataState =
    callDirection === 'Inbound' ? trafficMonitorDataState : outboundTrafficMonitorDataState;

  const paginationState =
    callDirection === 'Inbound'
      ? trafficMonitorPaginationState
      : outboundTrafficMonitorPaginationState;

  return {
    requestState,
    filterState,
    sortByState,
    pageNumberState,
    pageSizeState,
    startDateState,
    endDateState,
    directionState,
    orderByColumnState,
    orderByDescendingState,
    textSearchState,
    resultsDataState,
    paginationState,
  };
};
